/**
 * Which notification rows each settings screen shows.
 * CommonJS only. No object spread.
 */

const TASK_REMINDER_BASE = 'Every other Monday you get one message listing tasks due in the next 14 days, overdue tasks, and tasks with a reminder date in that window. Personal reminders cover a task overdue by 30 days, insurance, flood, and warranty renewals, and a yearly check-in.';

const BILLING_ITEM = {
  id: 'billing',
  title: 'Billing notices',
  description: 'A failed payment, the end of a grace period, or the end of a free period.',
  lockedNote: 'Always on, so a payment problem is not missed.',
  locked: true,
};

function taskReminderDescription(audience) {
  if (audience === 'sponsored') {
    return `${TASK_REMINDER_BASE} Personal reminders keep going through your sponsor's grace period.`;
  }
  if (audience === 'sponsorless') {
    return `${TASK_REMINDER_BASE} Personal reminders are sent while your plan is paid or in the free period. They pause while a payment needs attention.`;
  }
  return TASK_REMINDER_BASE;
}

function notificationModel(audience) {
  if (audience === 'agent') {
    return {
      role: 'agent',
      title: 'Notifications',
      intro: 'Choose email and push for each message.',
      showMaster: false,
      groups: [
        {
          id: 'to_homeowners',
          title: 'Messages to homeowners',
          items: [
            {
              id: 'task_reminders',
              title: 'Task reminders',
              description: 'Every other Monday, each homeowner gets one message listing tasks due in the next 14 days, overdue tasks, and tasks with a reminder date in that window.',
            },
            {
              id: 'project_reminders',
              title: 'Project reminders',
              description: 'A reminder to the homeowner before a project deadline.',
            },
            {
              id: 'project_completed',
              title: 'Project completed',
              description: 'When a project is marked complete.',
            },
          ],
        },
        {
          id: 'to_you',
          title: 'Messages to you',
          items: [
            {
              id: 'task_completed',
              title: 'Homeowner completed a task',
              description: 'When a homeowner marks a task complete.',
            },
            {
              id: 'help_requests',
              title: 'Help requests',
              description: 'When a homeowner asks for help on a task.',
            },
            {
              id: 'homeowner_moved',
              title: 'Homeowner moved',
              description: 'When a homeowner moves out of a home you manage.',
            },
            {
              id: 'weekly_client_activity',
              title: 'Weekly client activity',
              description: 'A weekly summary of activity across your clients.',
            },
          ],
        },
      ],
    };
  }

  const task = {
    id: 'task_reminders',
    title: 'Task reminders',
    description: taskReminderDescription(audience),
  };
  const digest = {
    id: 'monthly_digest',
    title: 'Monthly home digest',
    description: 'A monthly note about your home.',
  };
  const project = {
    id: 'project_updates',
    title: 'Project updates',
    description: 'When your sponsor creates or updates a project, or a project is due or completed.',
  };
  const report = {
    id: 'report_requests',
    title: 'Home History Report requests',
    description: 'When your sponsor asks you for a Home History Report.',
  };

  let items = [task, project, digest, report, BILLING_ITEM];
  let intro = 'Choose push and email for each kind of message.';
  if (audience === 'sponsorless') items = [task, digest, BILLING_ITEM];
  if (audience === 'readonly') {
    items = [BILLING_ITEM];
    intro = 'This home is read-only. You only receive billing notices.';
  }

  return {
    role: 'homeowner',
    title: 'Notification Settings',
    intro: intro,
    showMaster: true,
    masterDisabled: audience === 'readonly',
    groups: [{ id: 'homeowner', title: '', items: items }],
  };
}

module.exports = {
  notificationModel,
};
